import { useState, useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { useSuppliers } from "@/shared/hooks/useSuppliers";
import { useToastStore } from "@/shared/stores/toastStore";
import { useServiceWorkflowStore } from "@/shared/stores/serviceWorkflowStore";

export const useTableInitialization = () => {
  const { suppliers, loading: suppliersLoading } = useSuppliers();
  const router = useRouter();
  const { showToast } = useToastStore();
  const { serviceType, pId, initStage, initTableId } =
    useServiceWorkflowStore();

  const [tableId, setTableId] = useState<string | null>(null);

  useEffect(() => {
    if (suppliersLoading || !pId) {
      if (!suppliersLoading && initStage !== "intro") {
        setTableId(null);
      }
      return;
    }

    const supplier = suppliers.find((s) => s.id === pId);
    if (!supplier) {
      setTableId(null);
      if (initTableId) {
        showToast("Указанная таблица не найдена", "error");
        router.navigate({ to: "/" });
      }
      return;
    }

    const tableType = serviceType === "auto_jam" ? "jam" : "auto";
    const serviceTable = supplier.tables?.find(
      (t) => t.table_type === tableType,
    );

    if (serviceTable) {
      setTableId(serviceTable.id);
      if (initTableId && serviceTable.id !== initTableId) {
        showToast("Указанная таблица не найдена", "error");
        router.navigate({ to: "/" });
      }
    } else {
      setTableId(null);
      if (initStage === "payment" || initStage === "status") {
        showToast(
          initStage === "payment"
            ? "Необходимо добавить таблицу перед оплатой"
            : "Указанная таблица не найдена",
          "error",
        );
        if (initStage === "status") {
          router.navigate({ to: "/" });
        } else {
          useServiceWorkflowStore.setState({ initStage: "intro" });
        }
      }
    }
  }, [
    suppliers,
    pId,
    suppliersLoading,
    initStage,
    initTableId,
    serviceType,
    router,
    showToast,
  ]);

  return { tableId, isLoading: suppliersLoading };
};
